var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid pb-3",staticStyle:{"padding-top":"80px","min-height":"100vh"}},[_c('dynamic-page',{attrs:{"slug":"about_us"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }